module.exports = __webpack_public_path__ + "public/img/spxq.9e24c75a.png";